import { match } from 'ts-pattern';

import type { IGetWithdrawalEligibility } from '~/services/wallet/withdrawal-eligibility.schema';

export type WithdrawalGateDecision = 'proceed' | 'w9' | 'docv' | 'both' | 'indeterminate';

export const WITHDRAWAL_GATE_UNREACHABLE_DECISION: WithdrawalGateDecision = 'proceed';

export const toAmountCents = (dollars: number) => Math.round(dollars * 100);

export const decideWithdrawalGate = (
  eligibility: IGetWithdrawalEligibility | undefined,
  requestedAmountCents: number
): WithdrawalGateDecision => {
  if (!eligibility) {
    return 'indeterminate';
  }

  if (eligibility.evaluatedAmountCents !== requestedAmountCents) {
    return 'indeterminate';
  }

  if (eligibility.eligible) {
    return 'proceed';
  }

  return match(eligibility.gates)
    .with({ w9Required: true, docvRequired: true }, () => 'both' as const)
    .with({ w9Required: false, docvRequired: true }, () => 'docv' as const)
    .with({ w9Required: true, docvRequired: false }, () => 'w9' as const)
    .with({ w9Required: false, docvRequired: false }, () => 'indeterminate' as const)
    .exhaustive();
};
